export const list = [
  { id: '1', text: '17%', title: 'APR' },
  { id: '2', text: 'Biweekly', title: 'Re-staking Frequency' },
  { id: '3', text: 'YES', title: 'EcoIP Royalties' },
  { id: '4', text: 'YES', title: 'Bonus IP Portions' },
  { id: '5', text: 'YES', title: 'IP-Portions Royalty Returns' },
  { id: '6', text: 'YES', title: 'Liquidity Pool Reward' },
  { id: '7', text: 'LiteBacker', title: 'Status' },
];
